/* C1.5.8 (29 Oct 2026, Jullian, Kevin: "Don't make the wording imply that they can be cancelled"): the
   made-to-order line follows the cart. Any designed map (Coordinates) or name label in the cart:
   CFG.confirmText, default "Every model is printed to order. Changes and cancellation are not possible
   after ordering." Only ready-made maps: CFG.confirmTextReady, default "Every model is printed to order."
   Ready-made maps keep the legal right to cancel, so they are never told otherwise.
   C1.5.7 (29 Oct 2026, Jullian, Kevin: "show the display stand for those as well"): the display stand
   is offered with ready-made maps too (any line whose variant says \u00d8 15 or \u00d8 20, add-ons and the stand
   itself left out), not only with designed maps. Default made-to-order line, for both kinds of map:
   "Every model is printed to order. Maps you design or add a name label to can't be changed or
   cancelled after ordering." (snippets/mm-cart-everywhere sets the same text on every page.)
   C1.5.6 (29 Oct 2026, Jullian): the drawer now opens on every page (snippets/mm-cart-everywhere), so it
   also shows ready-made products. A ready-made line used to borrow the picture of the last map designed
   in the configurator when it was the only line; that fallback is now only for designed maps (they carry
   Coordinates). Ready-made lines show their product photo.
   BUILD 2026-10-27-C1.5.4 - MM cart drawer (C1.5.4, 27 Oct: whole prices without ,00; rest as C1.5.3)
   C1.5.3 (Kevin, 25 Oct), the "Add to your order" rows:
   - Bigger pictures (72px), every width: picture on the left, then the
     name, its line of text, and the price beside Add underneath.
   - Gift note: "A handwritten message for your loved one, on a premium
     card in a black envelope." Opened, a line above the box says what to
     write, and the box shows an example. Both fixed here, so the old
     theme setting text ("Your message on a card inside the box.") no
     longer shows.
   - Priority: "Ships by ... instead of ..." ("Skip the queue." cut).
   - Stand: wording unchanged.
   Was: BUILD 2026-10-25-C1.5.2 — MM cart drawer
   C1.5.2 (Kevin, 25 Oct): built on the live C1.5.1 (B6.0 colours).
   - Gift note row shows the black envelope photo of the Gift note product
     (its featured image, so changing the photo in Shopify changes it here)
     instead of the drawn envelope icon.
   - Priority production reads "Skip the queue. Ships by ... instead of ...".
   - Add-on prices (priority, gift note, stand) come from the products for
     the shopper's market (/products/<handle>.js is in their currency), so a
     UK shopper sees +£13, not the euro 15 typed in the theme settings.
     The settings are only the fallback if a product cannot be read.
     Handles: MM_CART.priorityHandle / giftHandle / standHandle override.
   C1.5.1 (Kevin, 23 Oct): on phones the "Add to your order" rows showed one
   line of each description, cut off. Now every word shows, bigger (name
   15 px, description 14 px): name, price and button on the first line, the
   description underneath at full width. Desktop: descriptions never cut.
   C1.5 (Kevin, 23 Oct): a calmer drawer that sells more.
   - Wall hanger no longer offered. One already in a cart still shows, with a
     stepper, so it can be taken out.
   - Free-shipping bar at the top. Header "Your cart" with a count.
   - Model line: place, then "size · frame · colour" on one line, price
     beside the name. The price breakdown and the coordinates line are gone.
     Muasher's notes box (his C1.4, merged here) sits behind "+ Add a note
     about this map" until there is something in it.
   - "Add another place": full-width tile, blue drawn plus in the middle; it
     says "Shipping is free with a second model" when that is true.
   - Extras as compact rows under "Add to your order": Priority production
     (one Add/Added toggle with its ship date), Gift note (shut until tapped,
     same no-message rule as C1.3), Display stand (Ø 15 / Ø 20 only).
   - Footer stays at the bottom while scrolling: total, the made-to-order
     line, "Checkout · total", the money-back promise, payment icons.
   - Styles are injected from this file (id mm-cart-c15-css), so
     assets/mm-configurator.css does not change. MM_CART.bundleTitle and
     bundleBody are no longer used.
   Merges: live C1.3.1 + C1.3.2 (drawn plus) + C1.4/C1.4.1 (stand, built-in
   stand settings) + Muasher's C1.4 of 22 Oct (notes box, Label line).
 */
/* cart notes + label display, 2026-10-22 (Muasher's C1.4) -- merged into C1.5.
   C1.4: each made-to-order model line (Coordinates, no _linkedTo) gets an
   optional "Notes about your map" box, saved to that line's "Notes"
   property on blur and after 800 ms without typing. Every other property is
   sent back exactly as it was. The configurator's "Label" property shows
   on the model line as "Label: PARIS" (hidden when it is "None"). */
/* BUILD 2026-10-21-C1.4.1 — MM cart drawer
   C1.4.1 (21 Oct): C1.4 with the stand settings built in, so the stand works
   with only this file replaced. They are used only while the configurator
   section does not send its own (no MM_CART.standVariantId key, i.e. section
   B4.11 or older). Once section B4.12 is installed its settings win, and an
   empty variant ID there switches the stand off.
   C1.4 (Kevin, 21 Oct): the rotating display stand is a second add-on, in a
   card under the hanger: a looping video of a model turning on it, its line,
   and "Add · price" (then a stepper, like the hanger). Settings come from the
   configurator section (MM_CART.stand*, section B4.12). It only shows when
   the cart holds a model in a size the stand fits (standSizes, default
   15 and 20 cm), or when a stand is already in the cart so it can be
   removed. The hanger card's own selectors now skip the stand card.
   C1.3.2 (Kevin, 19 Oct): the plus on "Add another model" was a typed "+",
   which the theme font sets off centre in its black circle. It is now a
   drawn plus (SVG), centred exactly whatever the font.
   C1.3.1 (16 Oct): C1.3 with two fixes. window.MM_BUILDS now says C1.3.1
   (C1.3 still said C1.2, so a live check could not tell them apart).
   Checkout waits for a message save at most 4 seconds, then goes anyway,
   so a hung request can never leave the button dead.
   C1.3 (Kevin, 16 Oct): a gift note needs a message. Order #1007 paid for a
   note that reached us as "(no message)". Now: Add gift note with an empty
   box does nothing but mark the box and ask for the message; clearing the
   box after adding removes the note line (no message, no note, no charge);
   Checkout is held while a note is in the cart with no message; a stale
   "(no message)" from the cart is never shown in the box. The 200 character
   cap and counter stay (theme setting giftMaxChars overrides).
   C1.2 (Kevin, 5 Oct): gift wrap is gone; the gift card is now a gift note.
   One card that opens and closes (ADD A GIFT NOTE, +/-), a line on what they
   get, a black envelope with the price under it, the message box beside it,
   and one full-width button. Wording, price and variant still come from the
   theme settings (MM_CART.gift*); the envelope is drawn here unless a gift
   image is set. */
/* Mounted Maps — cart drawer
 *
 * Replaces the redirect to /cart after adding a model. A made-to-order product
 * has more to say at that moment than a cart page does: what exactly was
 * configured, when it will ship, and the fact that it cannot be cancelled once
 * it enters production. It is also the highest-intent moment in the whole
 * session, which is where an accessory or a faster shift actually sells.
 *
 * Deliberately self-contained. It talks to Shopify's AJAX cart API and renders
 * its own markup, so it does not depend on the theme's cart drawer and cannot
 * be broken by a theme update.
 */
(function () {
  'use strict';

  var CFG = window.MM_CART || {};
  /* C1.4.1: built-in stand defaults (product 'Rotating display stand'). */
  if (!('standVariantId' in CFG)) {
    CFG.standVariantId = 55686299713865;
    CFG.standTitle = 'Rotating display stand';
    CFG.standBody = 'Turns your model slowly so every street catches the light. Fits \u00d8 15 and \u00d8 20 cm.';
    CFG.standPrice = 3500;
    CFG.standSizes = '15,20';
    CFG.standVideo = 'https://cdn.shopify.com/videos/c/vp/7f048aaf020a4df788f342a417cf0eb0/7f048aaf020a4df788f342a417cf0eb0.SD-480p-0.9Mbps-98306667.mp4';
    CFG.standImage = 'https://cdn.shopify.com/s/files/1/1017/2691/2841/files/mm-stand-poster.jpg?v=1792543722&width=200';
  }
  /* On window on purpose: the CDN minifies this file and drops a local var
     nothing reads, so a build number kept in one would never reach the served
     copy. window.MM_BUILDS is how you check what is actually live. */
  (window.MM_BUILDS = window.MM_BUILDS || {})['cart-drawer'] = '2026-10-29-C1.5.8';
  /* C1.2: the gift note card stays open or shut across re-renders. */
  var giftOpen = false;   /* C1.5: shut until tapped */
  var root = (window.Shopify && window.Shopify.routes)
    ? window.Shopify.routes.root : '/';

  /* C1.5.2: add-on prices and the gift photo, read from the products. The Ajax
     product endpoint answers in the shopper's own currency, which is what the
     cart will charge. Read once, with the first cart; a failed read leaves the
     theme setting in place. */
  var GIFT_IMG = 'https://cdn.shopify.com/s/files/1/1017/2691/2841/files/blackenvelope.webp?v=1791219265&width=240';
  var addonCents = {}, addonImg = {}, addonsLoad = null;
  function loadAddons() {
    if (addonsLoad) return addonsLoad;
    var list = [
      [CFG.priorityVariantId, CFG.priorityHandle || 'priority-production'],
      [CFG.giftVariantId, CFG.giftHandle || 'gift-wrap'],
      [CFG.standVariantId, CFG.standHandle || 'rotating-display-stand']
    ].filter(function (x) { return x[0] && x[1]; });
    addonsLoad = Promise.all(list.map(function (x) {
      return fetch(root + 'products/' + x[1] + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p) return;
          (p.variants || []).forEach(function (v) {
            if (String(v.id) === String(x[0]) && typeof v.price === 'number') addonCents[String(x[0])] = v.price;
          });
          if (p.featured_image) addonImg[String(x[0])] = p.featured_image;
        })
        .catch(function () {});
    }));
    return addonsLoad;
  }
  function addonPrice(variantId, fallback) {
    var c = addonCents[String(variantId)];
    return typeof c === 'number' ? c : (fallback || 0);
  }
  /* C1.5.3: the gift note words, fixed here (Kevin, 25 Oct). The cards are
     handwritten. */
  var GIFT_LINE = 'A handwritten message for your loved one, on a premium card in a black envelope.';
  var GIFT_HELP = 'Write what you want them to read when they open the envelope. We write it by hand on the card.';
  var GIFT_EXAMPLE = 'e.g. Happy anniversary! This is where we met. Love, Sam';
  function giftImage() {
    var u = addonImg[String(CFG.giftVariantId)];
    if (!u) return GIFT_IMG;
    if (u.indexOf('//') === 0) u = 'https:' + u;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=240';
  }

  /* ------------------------------ helpers ------------------------------- */

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Shopify money formats use {{amount}} style placeholders; cents in, string
     out. Falls back to a plain figure rather than throwing on an odd format. */
  function money(cents) {
    var fmt = CFG.moneyFormat || '€{{amount}}';
    var v = (cents || 0) / 100, dec = Math.round(cents || 0) % 100 === 0 ? 0 : 2;
    function withComma(n, dec) {
      var s = n.toFixed(dec);
      var p = s.split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return p.join('.');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      if (name === 'amount') return withComma(v, dec);
      if (name === 'amount_no_decimals') return withComma(Math.round(v), 0);
      if (name === 'amount_with_comma_separator') {
        return withComma(v, dec).replace(/,/g, ' ').replace('.', ',');
      }
      if (name === 'amount_no_decimals_with_comma_separator') {
        return withComma(Math.round(v), 0).replace(/,/g, ' ');
      }
      return withComma(v, dec);
    });
  }

  /* Working days only. Promising a Sunday dispatch is the kind of small lie
     that turns into a support ticket. */
  function shipDate(days) {
    var d = new Date();
    var added = 0;
    while (added < Math.max(0, days)) {
      d.setDate(d.getDate() + 1);
      var wd = d.getDay();
      if (wd !== 0 && wd !== 6) added++;
    }
    return d;
  }

  function fmtDate(d) {
    var today = new Date();
    var tomorrow = new Date(); tomorrow.setDate(today.getDate() + 1);
    function same(a, b) {
      return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth()
        && a.getDate() === b.getDate();
    }
    var label = d.toLocaleDateString(CFG.locale || undefined,
      { weekday: 'long', month: 'long', day: 'numeric' });
    if (same(d, tomorrow)) return 'Tomorrow, ' + d.toLocaleDateString(
      CFG.locale || undefined, { month: 'long', day: 'numeric' });
    return label;
  }

  function api(path, body) {
    /* A cart/change.js with no id is Shopify's "no valid id or line parameter",
       which is the red banner Kevin photographed -- a raw API string shown to a
       customer who cannot act on it. It can only happen when a handler fires
       with a line key that was captured before a re-render and no longer
       exists, so refuse to send it, say which call did it, and carry on. */
    if (/cart\/change/.test(path) && body && !body.id && body.line == null) {
      if (window.console) {
        console.warn('[mm cart] change called with no line id; ignored', body);
      }
      return Promise.resolve(null);
    }
    return fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'Cart error');
        return j;
      });
    });
  }

  /* Set a variant to an exact quantity, resolving its line key from the cart as
     it is RIGHT NOW rather than from whatever it was when the button was bound.
     Every "no valid id" in this drawer comes from a key captured at render time
     and used after a re-render, and this closes that off for good. */
  function setVariantQty(variantId, qty) {
    if (!variantId) return Promise.resolve(null);
    return getCart().then(function (fresh) {
      var key = lineIdFor(variantId, fresh);
      if (!key) {
        if (qty <= 0) return null;                 // already absent: nothing to do
        return api('cart/add.js', { items: [{ id: variantId, quantity: qty }] });
      }
      return api('cart/change.js', { id: key, quantity: qty });
    });
  }

  function getCart() {
    return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  /* --------------------------- cart structure --------------------------- */

  /* Add-on lines carry _linkedTo pointing at their model's coordinates, so the
     drawer can show one product with a price breakdown instead of five
     confusing separate lines. */
  /* C1.5.5 (29 Oct, Kevin: removing one map dropped the other from EUR 75 to
     EUR 65). Add-ons are linked to a PLACE (the centre coordinates), so two
     models of the same place (another size, frame or label) shared every
     add-on line: each showed all of them in its price, and removing one took
     them all, the other map's name label included. Now the add-on lines of a
     place are shared out between its models: name labels to the models that
     have a label (same wording first), anything else one per map in cart
     order, any extra on the last. Each model shows, changes and removes only
     its own share. A share is a copy of the line with quantity and price cut
     down to the share and _lineQty = the real line quantity. */
  function hasLabelProp(p) {
    var v = p && p.Label != null ? String(p.Label).trim() : '';
    return v !== '' && v !== 'None';
  }
  function isLabelAddon(x) {
    return x.handle === 'name-label' ||
      (!!CFG.nameLabelVariantId && String(x.variant_id) === String(CFG.nameLabelVariantId));
  }
  function shareOf(x, q) {
    var o = {}, k;
    for (k in x) if (Object.prototype.hasOwnProperty.call(x, k)) o[k] = x[k];
    o.original_line_price = Math.round(x.original_line_price * q / Math.max(x.quantity, 1));
    o.quantity = q;
    o._lineQty = x.quantity;
    return o;
  }
  function splitAddons(ms, xs) {
    var out = {}, capLabel = {};
    ms.forEach(function (m) {
      out[m.key] = [];
      capLabel[m.key] = hasLabelProp(m.properties) ? m.quantity : 0;
    });
    if (ms.length === 1) {
      out[ms[0].key] = xs.map(function (x) { return shareOf(x, x.quantity); });
      return out;
    }
    function give(m, x, q) {
      var list = out[m.key], i;
      for (i = 0; i < list.length; i++) {
        if (list[i].key === x.key) { list[i] = shareOf(x, list[i].quantity + q); return; }
      }
      list.push(shareOf(x, q));
    }
    xs.forEach(function (x) {
      var left = x.quantity, order, cap = {};
      if (isLabelAddon(x)) {
        var txt = String((x.properties || {}).Label || '');
        order = ms.filter(function (m) { return capLabel[m.key] > 0 && String(m.properties.Label) === txt; })
          .concat(ms.filter(function (m) { return capLabel[m.key] > 0 && String(m.properties.Label) !== txt; }));
        cap = capLabel;
      } else {
        order = ms;
        ms.forEach(function (m) { cap[m.key] = m.quantity; });
      }
      order.forEach(function (m) {
        if (left <= 0) return;
        var q = Math.min(left, cap[m.key]);
        if (q > 0) { give(m, x, q); cap[m.key] -= q; left -= q; }
      });
      if (left > 0) give((order.length ? order : ms)[(order.length ? order : ms).length - 1], x, left);
    });
    return out;
  }
  function group(cart) {
    var models = [], addons = {}, loose = [], places = {}, mine = {};
    cart.items.forEach(function (it) {
      var p = it.properties || {};
      if (p._linkedTo) {
        (addons[p._linkedTo] = addons[p._linkedTo] || []).push(it);
      } else if (p.Coordinates) {
        models.push(it);
        var k = String(p.Coordinates);
        (places[k] = places[k] || []).push(it);
      } else {
        loose.push(it);
      }
    });
    Object.keys(places).forEach(function (k) {
      var s = splitAddons(places[k], addons[k] || []);
      Object.keys(s).forEach(function (key) { mine[key] = s[key]; });
    });
    return models.map(function (m) {
      return { model: m, extras: mine[m.key] || [] };
    }).concat(loose.map(function (l) { return { model: l, extras: [] }; }));
  }

  /* The configurator stashes a thumbnail of the render it just showed, keyed on
     the centre coordinates. Showing that instead of the catalogue photo is the
     difference between "a 3D map" and "my street". */
  var THUMB_FALLBACK =
    '<svg viewBox="0 0 48 48" width="100%" height="100%" aria-hidden="true" ' +
    'style="display:block">' +
    '<rect width="48" height="48" rx="10" fill="#F3F4F6"/>' +
    '<circle cx="24" cy="24" r="14" fill="none" stroke="#B9BEC6" stroke-width="3"/>' +
    '<path d="M14 27c3-1.6 5-3.4 8-3.4s6 2.4 9 1.2" fill="none" stroke="#B9BEC6" ' +
    'stroke-width="2" stroke-linecap="round"/>' +
    '<circle cx="24" cy="24" r="3" fill="#B9BEC6"/></svg>';

  function ownThumb(item, isOnly) {
    try {
      var props = item.properties || {};
      /* B5.45 and later stamp the exact key on the line item, so neither file
         has to round a coordinate and hope the other rounds it the same way. */
      var hit = props._thumb && localStorage.getItem(props._thumb);
      if (hit) return hit;

      var raw = props._spec;
      if (raw) {
        var sp = JSON.parse(raw);
        if (sp && sp.centre) {
          var base = 'mm-thumb:' + sp.centre.lat.toFixed(5) + ',' +
                     sp.centre.lon.toFixed(5);
          /* Full key, for a line added before _thumb existed. */
          hit = localStorage.getItem(base + '|' +
                  (sp.diameterCm || (sp.size && sp.size.cm) || '?') + '|' +
                  (sp.frame || '?') + '|' + (sp.colourway || '?'));
          if (hit) return hit;
          /* Pre-B5.45 carts: keyed on the centre alone. Two models of the same
             place shared one picture, which is the bug, but a shared picture
             still beats the empty square this product would otherwise show. */
          hit = localStorage.getItem(base);
          if (hit) return hit;
        }
      }
      /* Nothing matched. If this is the only model in the cart the last thing
         rendered is certainly it. With several we cannot tell them apart, so
         we do not guess -- item.image is null on this product (it carries no
         catalogue images), so the caller draws a placeholder instead. */
      if (isOnly && props.Coordinates) return localStorage.getItem('mm-thumb:last');
      return null;
    } catch (e) { return null; }
  }

  /* C1.4: the stand fits some sizes only. A model's size comes from its
     variant ("Ø 20 cm / ..."), else from the saved spec. */
  function standSizes() {
    var raw = CFG.standSizes == null ? '15,20' : String(CFG.standSizes);
    return raw.split(/[^0-9]+/).filter(Boolean).map(Number);
  }
  function modelCm(it) {
    var m = /\u00d8\s*(\d+)/.exec(it.variant_title || '');   /* \u00d8 = the diameter sign, kept ASCII so no charset can break it */
    if (m) return +m[1];
    try {
      var sp = JSON.parse((it.properties || {})._spec || 'null');
      if (sp && sp.size && sp.size.cm) return +sp.size.cm;
    } catch (eS) {}
    m = /^(\d+)\s*[\u00d7x]/.exec(it.variant_title || '');
    return m ? +m[1] : 0;
  }
  /* C1.5.7: ready-made maps (\u00d8 15 / \u00d8 20 in the variant) get the stand too, not only
     designed maps. Add-on lines (_linkedTo) and the stand itself never count. */
  function standFits(cart) {
    if (!CFG.standVariantId) return false;
    var ok = standSizes();
    return cart.items.some(function (it) {
      var p = it.properties || {};
      if (p._linkedTo) return false;
      if (String(it.variant_id) === String(CFG.standVariantId)) return false;
      return ok.indexOf(modelCm(it)) >= 0;
    });
  }

  function lineIdFor(variantId, cart) {
    for (var i = 0; i < cart.items.length; i++) {
      if (String(cart.items[i].variant_id) === String(variantId)) return cart.items[i].key;
    }
    return null;
  }

  /* ------------------------------- drawer ------------------------------- */

  var overlay = null, panel = null, busy = false;
  var qtyTimer = null, qtyPending = null;
  var lastShape = null;

  function close() {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    document.documentElement.classList.remove('mm-cart-locked');
    setTimeout(function () {
      if (overlay && overlay.parentNode) overlay.parentNode.removeChild(overlay);
      overlay = null; panel = null;
    }, 260);
  }

  function open() {
    if (overlay) return refresh();
    overlay = el('div', 'mm-cart-overlay');
    panel = el('aside', 'mm-cart-panel');
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-label', 'Cart');
    overlay.appendChild(panel);
    /* Closing on any click whose target is the overlay is too eager. While a
       cart update is in flight the panel is inert, so a second rapid click
       lands on the backdrop and shuts the popup mid-edit. Requiring the press
       to both start and finish on the backdrop also stops a text selection
       that drags outside the panel from closing it. */
    var downOnBackdrop = false;
    overlay.addEventListener('mousedown', function (e) { downOnBackdrop = e.target === overlay; });
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay && downOnBackdrop) close();
      downOnBackdrop = false;
    });
    document.addEventListener('keydown', function onKey(e) {
      if (e.key === 'Escape') { close(); document.removeEventListener('keydown', onKey); }
    });
    document.body.appendChild(overlay);
    document.documentElement.classList.add('mm-cart-locked');
    requestAnimationFrame(function () { overlay.classList.add('is-open'); });
    panel.innerHTML = '<div class="mm-cart-loading">Loading your cart\u2026</div>';
    refresh();
  }

  /* What the markup's SHAPE depends on: which models are listed, and whether the
     accessory shows an Add button or a stepper. Everything else -- quantities,
     prices, which priority is selected, the total -- is text and classes that can
     be written in place. */
  function shapeOf(cart) {
    var acc = CFG.accessoryVariantId, keys = [], accQty = 0, standQty = 0;
    cart.items.forEach(function (it) {
      var v = String(it.variant_id);
      if (v === String(acc)) { accQty = it.quantity; return; }
      if (CFG.standVariantId && v === String(CFG.standVariantId)) { standQty = it.quantity; return; }
      /* Priority and gift wrap have no row of their own -- toggling them only
         moves a highlight and a button label, both of which patch. Counting
         their cart lines here forced a needless rebuild on every toggle. */
      if (v === String(CFG.priorityVariantId) || v === String(CFG.giftVariantId)) return;
      if ((it.properties || {})._linkedTo) return;
      keys.push(it.key);
    });
    return keys.join('|') + '#' + (accQty > 0 ? 'step' : 'add') +
      '#' + (standQty > 0 ? 'sstep' : (standFits(cart) ? 'sadd' : 'snone'));
  }

  /* Rewriting innerHTML on every tap loses the scroll position, whatever has
     focus, and anything half-typed in the gift message. Patching keeps the DOM
     and only touches the numbers that moved. */
  /* C1.5: priority is one row with an Add / Added button. */
  function prioPaint(on) {
    if (!panel) return;
    var row = panel.querySelector('.mm-cart-prio');
    var btn = panel.querySelector('.mm-prio-toggle');
    if (row) row.classList.toggle('is-on', !!on);
    if (btn) {
      btn.textContent = on ? 'Added' : 'Add';
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    }
  }

  function patch(cart) {
    var groups = group(cart);
    var accId = CFG.accessoryVariantId;

    cart.items.forEach(function (it) {
      if (accId && String(it.variant_id) === String(accId)) {
        var span = panel.querySelector('.mm-x-acc .mm-cart-qty span');
        var price = panel.querySelector('.mm-x-acc .mm-cart-up-price');
        if (span) span.textContent = it.quantity;
        if (price) price.textContent = money(it.original_line_price);
      }
      if (CFG.standVariantId && String(it.variant_id) === String(CFG.standVariantId)) {
        var sSpan = panel.querySelector('.mm-cart-stand .mm-cart-qty span');
        var sPrice = panel.querySelector('.mm-cart-stand .mm-cart-up-price');
        if (sSpan) sSpan.textContent = it.quantity;
        if (sPrice) sPrice.textContent = money(it.original_line_price);
      }
    });

    groups.forEach(function (g) {
      var node = panel.querySelector('.mm-cart-line[data-key="' + g.model.key + '"]');
      if (!node) return;
      var span = node.querySelector('.mm-cart-qty span');
      if (span && qtyPending == null) span.textContent = g.model.quantity;
      var lp = node.querySelector('.mm-cart-lineprice');
      if (lp) {
        lp.textContent = money(g.model.original_line_price +
          g.extras.reduce(function (a, x) { return a + x.original_line_price; }, 0));
      }
    });

    var prioOn = CFG.priorityVariantId ? !!lineIdFor(CFG.priorityVariantId, cart) : false;
    prioPaint(prioOn);

    var giftOn = CFG.giftVariantId ? !!lineIdFor(CFG.giftVariantId, cart) : false;
    var giftCard = panel.querySelector('.mm-cart-gift');
    var giftBtn = panel.querySelector('.mm-cart-gifttoggle');
    if (giftCard) giftCard.classList.toggle('is-on', giftOn);
    var giftState = panel.querySelector('.mm-gift-state');
    if (giftState) giftState.textContent = giftOn ? 'Added' : 'Add';
    if (giftBtn) {
      giftBtn.textContent = giftOn
        ? (CFG.giftRemoveLabel || 'Remove gift note')
        : (CFG.giftAddLabel || 'Add gift note');
    }

    var total = panel.querySelector('.mm-cart-total b');
    if (total) total.textContent = money(cart.total_price);
    var coTotal = panel.querySelector('.mm-co-total');
    if (coTotal) coTotal.textContent = money(cart.total_price);
    /* C1.5: the count in the header and the line under "Add another place". */
    var mgs = groups.filter(function (g) {
      var v = String(g.model.variant_id);
      return v !== String(CFG.priorityVariantId) && v !== String(CFG.accessoryVariantId) &&
             v !== String(CFG.giftVariantId) && !(CFG.standVariantId && v === String(CFG.standVariantId));
    });
    var cnt = panel.querySelector('.mm-cart-count');
    if (cnt && qtyPending == null) cnt.textContent = modelCount(mgs);
    var bsub = panel.querySelector('.mm-bundle-sub');
    if (bsub) bsub.textContent = bundleSub(cart, mgs);

    /* Patched in place like everything else here. Crossing the threshold does
       change the shape of this block, so that one case asks for a rebuild. */
    var shipBox = panel.querySelector('.mm-cart-ship');
    if (shipBox && CFG.freeShipOver > 0) {
      var left = CFG.freeShipOver - cart.total_price;
      var wasDone = shipBox.classList.contains('is-done');
      if ((left <= 0) !== wasDone) return render(cart);
      if (left > 0) {
        var amt = shipBox.querySelector('b');
        var fill = shipBox.querySelector('.mm-cart-ship-bar i');
        if (amt) amt.textContent = money(left);
        if (fill) {
          fill.style.width = Math.max(4, Math.min(100,
            Math.round((cart.total_price / CFG.freeShipOver) * 100))) + '%';
        }
      }
    }

    // handlers close over the old cart, so rebind them against the new one
    wire(cart, groups, CFG.priorityVariantId ? lineIdFor(CFG.priorityVariantId, cart) : null,
         true);
  }

  function refresh() {
    if (qtyTimer) return Promise.resolve();   // an edit is still being typed
    return Promise.all([getCart(), loadAddons()]).then(function (res) {
      var cart = res[0];
      var shape = shapeOf(cart);
      if (panel && lastShape === shape && panel.querySelector('.mm-cart-foot')) {
        return patch(cart);
      }
      lastShape = shape;
      render(cart);
    }).catch(function (e) {
      if (panel) panel.innerHTML = '<div class="mm-cart-loading">' + esc(e.message) + '</div>';
    });
  }

  /* Takes a FUNCTION, not a promise, so the request is not created until its
     turn. Shopify rejects concurrent cart writes, and the old version dropped
     any tap that landed mid-request -- so a quick second tap silently did
     nothing. These queue instead, and nothing is dimmed: the number on screen
     has already moved, so a greyed-out panel only says "wait" for no reason. */
  var chain = Promise.resolve();
  function mutate(makeRequest) {
    chain = chain
      .then(function () { return makeRequest(); })
      .then(function () { return refresh(); })
      /* C1.5.5: the cart guard (snippets/mm-cart-guard.liquid) checks every
         labelled map still has its paid label line. It used to run only on
         page load and theme cart events, never after a change made here. */
      .then(function () {
        try { if (window.MMCartGuardRun) window.MMCartGuardRun(); } catch (e) {}
      })
      .catch(function (e) {
        /* The customer gets a sentence they can act on; the API's own wording
           goes to the console, where it is useful. "no valid id or line
           parameter" told a buyer nothing and looked broken. */
        if (window.console) console.warn('[mm cart]', e && e.message, e);
        if (panel) {
          var bar = panel.querySelector('.mm-cart-err');
          if (bar) {
            bar.textContent = 'That did not go through. Your cart is unchanged \u2014 try again.';
            bar.classList.remove('mm-hide');
          }
        }
        return refresh();          // resync after a failure, then carry on
      });
    return chain;
  }

  /* ------------------------ per-model notes (C1.4) ---------------------- */

  /* cart notes + label display, 2026-10-22. The note is a line item property
     like Coordinates or Label, so it reaches the order with the model it
     belongs to. Changing a property gives the line a new key, so a save writes
     the new key onto the line in place and patches around the box. A rebuild
     would replace the box the customer may still be typing in. */
  var NOTE_MAX = 300, NOTE_WAIT = 800, noteSeq = 0, noteAlias = {};

  /* A key replaced by a note save, followed to the key the line has now. */
  function liveKeyOf(k) {
    for (var n = 0; k && noteAlias[k] && n < 50; n++) k = noteAlias[k];
    return k;
  }

  /* A box replaced by a full rebuild, followed to the box on screen now. */
  function liveNote(ta) {
    for (var n = 0; ta && ta._mmNext && n < 50; n++) ta = ta._mmNext;
    return ta;
  }

  /* Styles for the notes box and the label, injected once so this file
     carries the whole feature. Same border, radius, type and focus colour as
     the gift message box in assets/mm-configurator.css. */
  (function noteCss() {
    try {
      if (document.getElementById('mm-cart-note-css')) return;
      var st = document.createElement('style');
      st.id = 'mm-cart-note-css';
      st.textContent = [
        '.mm-cart-label{margin:0 0 5px;font-size:13px;color:#4A4F55;overflow-wrap:anywhere}',
        '.mm-cart-line.mm-has-note{flex-wrap:wrap}',
        /* Keeps the stepper beside the text; only the notes box wraps. */
        '@media (min-width:621px){.mm-cart-line.mm-has-note .mm-cart-info{flex-basis:0}}',
        '.mm-cart-note{flex:0 0 calc(100% - 110px);min-width:0;margin:2px 0 0 110px}',
        '.mm-cart-note-lab{display:block;margin:0 0 5px;font-size:13px;font-weight:600;color:#23262A;cursor:text}',
        '.mm-cart-note-lab small{font-size:12px;font-weight:400;color:#8A9097}',
        '.mm-cart-notemsg{display:block;width:100%;padding:9px 11px;border:1px solid #D8DBDE;' +
          'border-radius:12px;font:inherit;font-size:13.5px;line-height:1.45;resize:vertical;' +
          'box-sizing:border-box;background:#FAFAFB;color:#23262A;margin:0;transition:border-color .2s ease}',
        '.mm-cart-notemsg::placeholder{color:#9AA0A6}',
        '.mm-cart-notemsg:focus{outline:none;border-color:#1E4FC4;background:#fff}',
        '.mm-cart-note-foot{display:flex;justify-content:space-between;align-items:baseline;gap:10px;margin:5px 0 0}',
        '.mm-cart-notestat{font-size:12px;color:#3F5230;min-height:1em}',
        '.mm-cart-notestat.is-err{color:#8C2F22}',
        '.mm-cart-notecount{margin-left:auto;font-style:normal;font-size:12px;color:#8A9097;' +
          'font-variant-numeric:tabular-nums}',
        '@media (max-width:620px){.mm-cart-note{flex-basis:100%;margin-left:0}}',
        /* iOS zooms on focus under 16px, as with the gift box. */
        '@media (max-width:940px){.mm-cart-notemsg{font-size:16px}}'
      ].join('\n');
      (document.head || document.documentElement).appendChild(st);
    } catch (eC) { /* unstyled is still usable */ }
  })();

  /* C1.5: the new layout's styles, injected once so this file carries the
     whole drawer and assets/mm-configurator.css does not have to change.
     Every rule is prefixed with .mm-cart-panel so it wins over the old ones. */
  (function c15Css() {
    try {
      if (document.getElementById('mm-cart-c15-css')) return;
      var P = '.mm-cart-panel ';
      var st = document.createElement('style');
      st.id = 'mm-cart-c15-css';
      st.textContent = [
        '.mm-cart-overlay .mm-cart-panel{width:min(560px,100%)}',
        P + '.mm-cart-head{padding:16px 20px 12px;border-bottom:1px solid #E9EBEE}',
        P + '.mm-cart-head h2{display:flex;align-items:center;gap:8px;font-size:20px;color:#121417}',
        P + '.mm-cart-count{box-sizing:border-box;display:inline-grid;place-items:center;min-width:22px;height:22px;padding:0 7px;' +
          'border-radius:8px;background:#121417;color:#fff;font-size:12px;font-weight:700;letter-spacing:0}',
        P + '.mm-cart-body{padding:12px 20px 6px}',
        P + '.mm-cart-empty{padding:40px 10px;text-align:center;color:#6B7076}',
        P + '.mm-cart-empty p{margin:0}',
        P + '.mm-cart-emptybtn{display:inline-flex;margin-top:14px;padding:12px 22px;border-radius:8px;' +
          'background:#121417;color:#fff!important;text-decoration:none!important;font-weight:600;font-size:15px}',

        /* free shipping, now at the top */
        P + '.mm-cart-ship{margin:0 0 4px;padding:10px 12px;background:#fff;border:1px solid #E9EBEE;border-radius:12px}',
        P + '.mm-cart-ship p{display:flex;align-items:center;gap:5px;flex-wrap:wrap;margin:0 0 7px;font-size:13px;color:#23262A}',
        P + '.mm-cart-ship.is-done p{margin:0;color:#1E4FC4;font-weight:600}',
        P + '.mm-cart-ship-bar{height:6px;background:#ECEEE8}',
        P + '.mm-cart-ship-bar i{background:#1E4FC4}',

        /* model line */
        P + '.mm-cart-line{gap:14px;padding:14px 0;border-bottom:1px solid #E9EBEE;align-items:flex-start;flex-wrap:wrap}',
        P + '.mm-cart-thumb{width:80px;height:80px;border-radius:12px}',
        P + '.mm-cart-info{flex:1 1 0;min-width:0}',
        P + '.mm-cart-top{display:flex;align-items:baseline;justify-content:space-between;gap:12px}',
        P + '.mm-cart-info h3{margin:0;font-size:16px;font-weight:700;color:#121417;overflow-wrap:anywhere}',
        P + '.mm-cart-lineprice{min-width:0;font-size:16px;font-weight:600;white-space:nowrap;color:#121417}',
        P + '.mm-cart-sub{margin:3px 0 0;font-size:13px;color:#6B7076}',
        P + '.mm-cart-label{margin:3px 0 0}',
        P + '.mm-cart-extra{margin:3px 0 0;font-size:12.5px;color:#4A4F55}',
        P + '.mm-cart-ctl{display:flex;align-items:center;flex-wrap:wrap;gap:8px 16px;margin-top:10px}',
        P + '.mm-cart-qty button{width:28px;height:28px}',
        P + '.mm-cart-link{padding:0;font-size:13px;color:#1E4FC4}',
        P + '.mm-cart-note{display:none;flex:0 0 calc(100% - 94px);margin:10px 0 0 94px}',
        P + '.mm-cart-line.is-note-open .mm-cart-note{display:block}',

        /* add another place */
        P + '.mm-cart-bundle{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:8px;' +
          'width:100%;margin:14px 0 4px;padding:16px 14px;background:#fff;border:1.5px dashed rgba(30,79,196,.5);' +
          'border-radius:12px;text-align:center;cursor:pointer;transition:background .15s ease,border-color .15s ease}',
        P + '.mm-cart-bundle:hover{background:#F4F8FE;border-color:#1E4FC4}',
        P + '.mm-cart-bundle i{width:38px;height:38px;border-radius:50%;background:#1E4FC4;color:#fff;' +
          'display:grid;place-items:center;font-size:0;line-height:0;box-shadow:0 6px 14px rgba(30,79,196,.3);transition:transform .15s ease}',
        P + '.mm-cart-bundle:hover i{transform:scale(1.06)}',
        P + '.mm-cart-bundle i svg{display:block}',
        P + '.mm-cart-bundle span{display:flex;flex-direction:column;align-items:center;gap:2px}',
        P + '.mm-cart-bundle strong{font-size:15px;color:#121417}',
        P + '.mm-cart-bundle em{font-style:normal;font-size:12.5px;color:#6B7076}',

        /* extras */
        P + '.mm-xs{margin:16px 0 4px}',
        P + '.mm-xs h4{margin:0 0 8px;font-size:11.5px;font-weight:700;letter-spacing:.12em;text-transform:uppercase;color:#7A7F86}',
        P + '.mm-x{display:flex;align-items:center;gap:12px;margin:0 0 8px;padding:10px 12px;background:#fff;' +
          'border:1.5px solid #E9EBEE;border-radius:12px;transition:border-color .15s ease}',
        P + '.mm-x.is-on{border-color:#1E4FC4}',
        P + '.mm-x-ic{flex:0 0 40px;width:40px;height:40px;border-radius:10px;background:#F1F0EC;color:#23262A;display:grid;place-items:center}',
        P + '.mm-x.is-on .mm-x-ic{background:#E8F1FD;color:#1E4FC4}',
        P + '.mm-stand-vid{flex:0 0 40px;width:40px;height:40px;border-radius:10px;object-fit:cover;background:#F3F4F6;display:block}',
        P + '.mm-x-img{flex:0 0 40px;width:40px;height:40px;border-radius:10px;object-fit:cover;background:#F3F4F6;display:block}',
        P + '.mm-x-txt{flex:1 1 auto;min-width:0;text-align:left}',
        P + '.mm-x-txt strong{display:block;font-size:14px;color:#121417}',
        P + '.mm-x-txt p,' + P + '.mm-x-p{display:block;margin:1px 0 0;font-size:12.5px;line-height:1.35;color:#6B7076;font-weight:400}',
        P + '.mm-x-txt p b{color:#23262A;font-weight:600}',
        P + '.mm-x-side{flex:0 0 auto;display:flex;align-items:center;gap:10px;margin-left:auto}',
        P + '.mm-x-price{font-size:13.5px;color:#23262A;white-space:nowrap}',
        P + '.mm-x-btn{box-sizing:border-box;flex:0 0 auto;display:inline-flex;align-items:center;justify-content:center;gap:4px;min-width:64px;height:32px;' +
          'padding:0 14px;border-radius:8px;border:1.5px solid #121417;background:#fff;color:#121417;font:inherit;' +
          'font-size:13px;font-weight:600;line-height:1;cursor:pointer;white-space:nowrap}',
        P + '.mm-x.is-on .mm-x-btn{background:#1E4FC4;border-color:#1E4FC4;color:#fff}',
        P + '.mm-x.is-on .mm-x-btn::before{content:"\\2713";font-size:12px}',
        P + '.mm-x .mm-cart-up-price{font-size:13.5px;white-space:nowrap}',

        /* gift note row: a bar that opens */
        P + '.mm-x.mm-cart-gift{display:block;padding:0;overflow:hidden}',
        P + '.mm-cart-gift .mm-cart-gift-bar{display:flex;align-items:center;gap:12px;width:100%;margin:0;padding:10px 12px;' +
          'background:none;border:0;font:inherit;font-size:inherit;letter-spacing:0;text-transform:none;color:inherit;text-align:left;cursor:pointer}',
        P + '.mm-cart-gift .mm-cart-gift-bar .mm-x-side{pointer-events:none}',
        P + '.mm-cart-gift .mm-cart-gift-body{display:none;padding:0 12px 12px}',
        P + '.mm-cart-gift.is-open .mm-cart-gift-body{display:block}',
        P + '.mm-cart-gift .mm-cart-giftmsg{min-height:72px;margin:0}',
        P + '.mm-gift-foot{display:flex;align-items:center;justify-content:space-between;gap:10px;margin-top:8px}',
        P + '.mm-gift-foot .mm-cart-giftcount{margin:0;text-align:left}',
        P + '.mm-cart-gift .mm-cart-gifttoggle{display:inline-flex;width:auto;padding:9px 16px;font-size:13px;font-weight:600;' +
          'letter-spacing:0;text-transform:none}',
        P + '.mm-cart-gift.is-on .mm-cart-gifttoggle{background:#fff;color:#121417;box-shadow:inset 0 0 0 1.5px #121417}',

        /* footer that stays put */
        P + '.mm-cart-foot{position:sticky;bottom:0;z-index:2;background:#FFFFFF;border-top:1px solid #E9EBEE;' +
          'padding:12px 20px calc(14px + env(safe-area-inset-bottom,0px))}',
        P + '.mm-cart-foot::before{display:none}',
        P + '.mm-cart-total span{font-size:16px;font-weight:600}',
        P + '.mm-cart-total b{font-size:20px}',
        P + '.mm-cart-tax{margin:0 0 6px;font-size:11.5px}',
        P + '.mm-cart-terms{margin:0 0 10px;font-size:11.5px;line-height:1.45;color:#6B7076}',
        P + '.mm-cart-checkout{display:flex;align-items:center;justify-content:center;gap:8px;margin-top:0;padding:15px 18px;' +
          'border-radius:8px;font-size:16px;font-weight:600;box-shadow:0 8px 20px rgba(30,79,196,.28)}',
        P + '.mm-co-total{font-weight:700}',
        P + '.mm-co-total::before{content:"\\00b7";margin:0 6px 0 0;opacity:.75;font-weight:400}',
        P + '.mm-cart-promise{display:flex;align-items:center;justify-content:center;gap:6px;margin:10px 0 0;' +
          'font-size:12.5px;font-weight:600;line-height:1.35;color:#1E4FC4;text-align:center}',
        P + '.mm-cart-promise svg{flex:0 0 auto}',
        P + '.mm-cart-icons{margin-top:8px}',
        P + '.mm-cart-icons img{height:18px}',

        '@media (max-width:940px){' + P + '.mm-cart-giftmsg{font-size:16px}}',
        '@media (max-width:620px){' +
          P + '.mm-cart-head{padding:16px 16px 10px}' +
          P + '.mm-cart-body{padding:10px 16px 4px}' +
          P + '.mm-cart-thumb{width:64px;height:64px}' +
          P + '.mm-cart-line{gap:12px}' +
          P + '.mm-cart-note{flex-basis:100%;margin-left:0}' +
          /* C1.5.1 (Kevin): phones show every word, at a bigger size, never cut
             off. Name, price and button on the first line; the description
             underneath at full width. */
          P + '.mm-x{padding:12px}' +
          P + '.mm-x,' + P + '.mm-cart-gift .mm-cart-gift-bar{flex-wrap:wrap;align-items:center;column-gap:12px;row-gap:4px}' +
          P + '.mm-x-ic,' + P + '.mm-x-img,' + P + '.mm-stand-vid{order:1;flex-basis:40px;width:40px;height:40px;align-self:center}' +
          P + '.mm-x-txt{display:contents}' +
          P + '.mm-x-txt strong{order:2;flex:1 1 0;min-width:0;align-self:center;font-size:15px;line-height:1.3}' +
          P + '.mm-x-side{order:3;flex-direction:column;align-items:flex-end;gap:5px;align-self:center}' +
          P + '.mm-x-txt p,' + P + '.mm-x-p{order:4;flex:0 0 100%;box-sizing:border-box;max-width:100%;padding-left:52px;margin:2px 0 0;font-size:14px;line-height:1.4;color:#5C6066}' +
          P + '.mm-x-price,' + P + '.mm-x .mm-cart-up-price{font-size:14px;font-weight:600}' +
          P + '.mm-x-btn{min-width:66px;height:34px;padding:0 14px;font-size:14px}' +
          P + '.mm-cart-gift .mm-cart-gift-bar{padding:12px}' +
          P + '.mm-cart-gift .mm-cart-gift-body{padding:0 10px 10px}' +
          P + '.mm-cart-foot{padding:10px 16px calc(10px + env(safe-area-inset-bottom,0px))}' +
          P + '.mm-cart-checkout{padding:14px 16px}' +
          P + '.mm-cart-promise{margin-top:8px;font-size:12px}' +
          P + '.mm-cart-icons img{height:16px}' +
        '}',
        /* C1.5.3 (Kevin): bigger pictures on every width. Picture on the
           left; the name, its line of text, then the price and Add. */
        P + '.mm-x,' + P + '.mm-cart-gift .mm-cart-gift-bar{display:grid;grid-template-columns:72px minmax(0,1fr);' +
          'column-gap:14px;row-gap:3px;align-items:start;padding:12px}',
        P + '.mm-x.mm-cart-gift{display:block;padding:0}',
        P + '.mm-x-ic,' + P + '.mm-x-img,' + P + '.mm-stand-vid{grid-column:1;grid-row:1 / span 3;flex:none;' +
          'width:72px;height:72px;border-radius:12px;align-self:start}',
        P + '.mm-x-txt{display:contents}',
        P + '.mm-x-txt strong{grid-column:2;grid-row:1;align-self:auto;font-size:15.5px;line-height:1.3}',
        P + '.mm-x-txt p,' + P + '.mm-x-p{grid-column:2;grid-row:2;flex:none;max-width:none;padding-left:0;margin:0;' +
          'font-size:14px;line-height:1.4;color:#5C6066}',
        P + '.mm-x-side{grid-column:2;grid-row:3;flex-direction:row;align-items:center;justify-content:flex-end;' +
          'gap:12px;margin:6px 0 0;align-self:auto}',
        P + '.mm-x-price,' + P + '.mm-x .mm-cart-up-price{font-size:15px;font-weight:600}',
        P + '.mm-x-btn{min-width:72px;height:38px;padding:0 16px;font-size:14.5px}',
        P + '.mm-cart-gift .mm-cart-gift-body{padding:0 12px 12px}',
        P + '.mm-gift-help{margin:2px 0 8px;font-size:14px;line-height:1.4;font-weight:500;color:#23262A;text-align:left}',
        '@media (prefers-reduced-motion:reduce){' + P + '.mm-cart-bundle,' + P + '.mm-cart-bundle i,' + P + '.mm-x{transition:none}}'
      ].join('\n');
      (document.head || document.documentElement).appendChild(st);
    } catch (eC) { /* unstyled is still usable */ }
  })();

  /* "None" is the configurator saying there is no label. */
  function noteLabel(p) {
    var v = (p && p.Label != null) ? String(p.Label).trim() : '';
    return /^none$/i.test(v) ? '' : v;
  }

  function noteClean(s) {
    return String(s == null ? '' : s).trim().slice(0, NOTE_MAX);
  }

  function noteHtml(m, p) {
    var id = 'mm-cart-note-' + (++noteSeq);
    var val = p.Notes == null ? '' : String(p.Notes);
    return '<div class="mm-cart-note">' +
      '<label class="mm-cart-note-lab" for="' + id + '">Notes about your map ' +
        '<small>(optional)</small></label>' +
      '<textarea class="mm-cart-notemsg" id="' + id + '" rows="3" maxlength="' + NOTE_MAX + '"' +
        ' placeholder="Anything we should know about your map?"' +
        ' aria-describedby="' + id + '-n"' +
        ' data-coords="' + esc(p.Coordinates) + '" data-variant="' + esc(m.variant_id) + '">' +
        esc(val) + '</textarea>' +
      '<div class="mm-cart-note-foot">' +
        '<span class="mm-cart-notestat" role="status" aria-live="polite"></span>' +
        '<em class="mm-cart-notecount" id="' + id + '-n">' + val.length + ' / ' + NOTE_MAX + '</em>' +
      '</div></div>';
  }

  function notePart(ta, cls) {
    var w = ta.closest('.mm-cart-note');
    return w ? w.querySelector(cls) : null;
  }

  function noteCount(ta) {
    var c = notePart(ta, '.mm-cart-notecount');
    if (c) c.textContent = ta.value.length + ' / ' + NOTE_MAX;
  }

  function noteStatus(ta, msg, bad) {
    var s = notePart(ta, '.mm-cart-notestat');
    if (!s) return;
    s.textContent = msg || '';
    s.classList.toggle('is-err', !!bad);
  }

  /* Blank values are ignored on both sides: the cart may drop them. */
  function sameProps(a, b) {
    a = a || {}; b = b || {};
    var ka = Object.keys(a).filter(function (k) { return a[k] != null && a[k] !== ''; });
    var kb = Object.keys(b).filter(function (k) { return b[k] != null && b[k] !== ''; });
    if (ka.length !== kb.length) return false;
    for (var i = 0; i < ka.length; i++) {
      if (kb.indexOf(ka[i]) === -1 || String(a[ka[i]]) !== String(b[ka[i]])) return false;
    }
    return true;
  }

  /* The line a note belongs to: by key first, then by the exact properties
     just sent, then by its coordinates when only one model has them. */
  function noteLine(cart, key, coords, vid, props) {
    var items = (cart && cart.items) || [], i, p, hits = [];
    if (key) {
      for (i = 0; i < items.length; i++) if (items[i].key === key) return items[i];
    }
    if (props) {
      for (i = 0; i < items.length; i++) {
        if (String(items[i].variant_id) === String(vid) &&
            sameProps(items[i].properties, props)) return items[i];
      }
    }
    for (i = 0; i < items.length; i++) {
      p = items[i].properties || {};
      if (!p._linkedTo && p.Coordinates != null && String(p.Coordinates) === String(coords) &&
          (!vid || String(items[i].variant_id) === String(vid))) hits.push(items[i]);
    }
    return hits.length === 1 ? hits[0] : null;
  }

  /* New key onto the line node, then the same in-place patch a quantity change
     gets. patch() rebinds the buttons against the new cart, so the stepper and
     the linked add-ons keep working with the new key. */
  function noteApply(r) {
    if (!r || !r.cart) return;
    if (r.oldKey && r.newKey && r.oldKey !== r.newKey) noteAlias[r.oldKey] = r.newKey;
    if (!panel) return;
    var lines = panel.querySelectorAll('.mm-cart-line'), found = false;
    for (var i = 0; i < lines.length; i++) {
      var k = lines[i].getAttribute('data-key');
      if (r.newKey && (k === r.newKey || k === r.oldKey)) {
        if (k !== r.newKey) lines[i].setAttribute('data-key', r.newKey);
        found = true;
      }
    }
    if (!found || !panel.querySelector('.mm-cart-foot')) return refresh();
    lastShape = shapeOf(r.cart);
    patch(r.cart);
  }

  /* Queued on the same chain as every other cart write. The text and the line
     are read when its turn comes, so a burst of typing makes one request, and
     the properties come from the cart as it is at that moment. */
  function saveNote(ta0) {
    var ta = liveNote(ta0);
    if (!ta) return chain;
    if (ta._mmT) { clearTimeout(ta._mmT); ta._mmT = null; }
    if (ta._mmDead || ta._mmQueued || noteClean(ta.value) === ta._mmSaved) return chain;
    ta._mmQueued = true;
    chain = chain.then(function () {
      ta._mmQueued = false;
      var box = liveNote(ta);
      if (!box || (box._mmDead && !box._mmNext)) return;
      box._mmQueued = false;
      var text = noteClean(box.value);
      if (text === box._mmSaved) return;
      var line = box.closest('.mm-cart-line');
      var key = liveKeyOf(line ? line.getAttribute('data-key') : null);
      var coords = box.getAttribute('data-coords'), vid = box.getAttribute('data-variant');
      return getCart().then(function (fresh) {
        var it = noteLine(fresh, key, coords, vid);
        if (!it) throw new Error('note: line not found in cart');
        var cur = it.properties || {};
        if (noteClean(cur.Notes) === text) {
          return { cart: fresh, oldKey: key || it.key, newKey: it.key };
        }
        /* Every property goes back exactly as the cart has it, underscore
           ones included. Only Notes is set, or left out when emptied. */
        var props = {};
        Object.keys(cur).forEach(function (k) { if (k !== 'Notes') props[k] = cur[k]; });
        if (text) props.Notes = text;
        return api('cart/change.js', { id: it.key, quantity: it.quantity, properties: props })
          .then(function (next) {
            if (!next || !next.items) throw new Error('note: no cart in response');
            var hit = noteLine(next, null, coords, vid, props);
            return { cart: next, oldKey: it.key, newKey: hit ? hit.key : null };
          });
      }).then(function (r) {
        var live = liveNote(box);
        live._mmSaved = text;
        noteStatus(live, 'Saved', false);
        return noteApply(r);
      }).catch(function (e) {
        if (window.console) console.warn('[mm cart] note not saved', e && e.message, e);
        noteStatus(liveNote(box), "Couldn't save, try again", true);
      });
    });
    return chain;
  }

  /* Checkout leaves once the chain is empty, so anything typed goes first. */
  function flushNotes() {
    if (!panel) return;
    Array.prototype.forEach.call(panel.querySelectorAll('.mm-cart-notemsg'), function (ta) {
      if (ta._mmT || noteClean(ta.value) !== ta._mmSaved) saveNote(ta);
    });
  }

  /* Wired once per box. Patches keep the node, so it keeps its listeners. */
  function wireNotes() {
    if (!panel) return;
    Array.prototype.forEach.call(panel.querySelectorAll('.mm-cart-notemsg'), function (ta) {
      if (ta._mmWired) return;
      ta._mmWired = true;
      if (ta._mmSaved == null) ta._mmSaved = noteClean(ta.defaultValue);
      noteCount(ta);
      ta.addEventListener('input', function () {
        noteCount(ta);
        noteStatus(ta, '', false);
        if (ta._mmT) clearTimeout(ta._mmT);
        ta._mmT = setTimeout(function () { ta._mmT = null; saveNote(ta); }, NOTE_WAIT);
      });
      ta.addEventListener('blur', function () { saveNote(ta); });
    });
  }

  /* A full rebuild keeps what was typed, the cursor and the status. */
  function noteKeep() {
    if (!panel) return [];
    var act = document.activeElement;
    return Array.prototype.map.call(panel.querySelectorAll('.mm-cart-notemsg'), function (ta) {
      var line = ta.closest('.mm-cart-line'), f = ta === act, st = notePart(ta, '.mm-cart-notestat');
      ta._mmDead = true;
      return {
        node: ta, key: line ? line.getAttribute('data-key') : null,
        coords: ta.getAttribute('data-coords'), vid: ta.getAttribute('data-variant'),
        value: ta.value, focus: f,
        s: f ? ta.selectionStart : null, e: f ? ta.selectionEnd : null,
        msg: st ? st.textContent : '', bad: st ? st.classList.contains('is-err') : false
      };
    });
  }

  function noteRestore(kept) {
    if (!panel || !kept.length) return;
    Array.prototype.forEach.call(panel.querySelectorAll('.mm-cart-notemsg'), function (ta) {
      var line = ta.closest('.mm-cart-line');
      var key = line ? line.getAttribute('data-key') : null;
      var hit = null, i;
      for (i = 0; i < kept.length; i++) {
        if (!kept[i].used && kept[i].key === key) { hit = kept[i]; break; }
      }
      if (!hit) {
        var c = kept.filter(function (k) {
          return !k.used && k.coords === ta.getAttribute('data-coords') &&
                 k.vid === ta.getAttribute('data-variant');
        });
        if (c.length === 1) hit = c[0];
      }
      if (!hit) return;
      hit.used = true;
      if (hit.node) hit.node._mmNext = ta;
      if (hit.value !== ta.value) { ta.value = hit.value; noteCount(ta); }
      if (hit.msg) noteStatus(ta, hit.msg, hit.bad);
      if (hit.node && hit.node._mmT) {
        clearTimeout(hit.node._mmT); hit.node._mmT = null;
        ta._mmT = setTimeout(function () { ta._mmT = null; saveNote(ta); }, NOTE_WAIT);
      }
      if (hit.focus) {
        try { ta.focus({ preventScroll: true }); } catch (eF) { try { ta.focus(); } catch (eF2) {} }
        try { ta.setSelectionRange(hit.s, hit.e); } catch (eS) {}
      }
    });
  }

  /* -------------------------------- render ------------------------------ */

  /* C1.5: per-place "note open" state, so a re-render keeps a note box open. */
  var noteOpen = {};

  /* C1.5: what the "Add another place" tile says under its title. When one
     more model of the cheapest size already in the cart would clear the
     free-shipping line, it says so; otherwise the gift angle. */
  function bundleSub(cart, modelGroups) {
    var over = CFG.freeShipOver > 0 ? CFG.freeShipOver : 0;
    var left = over ? over - cart.total_price : 0;
    if (left > 0) {
      var cheapest = 0;
      /* C1.5.6: ready-made models count too (they have no Coordinates). */
      modelGroups.forEach(function (g) {
        var unit = g.model.original_line_price / Math.max(g.model.quantity, 1);
        if (!cheapest || unit < cheapest) cheapest = unit;
      });
      if (cheapest && cheapest >= left) return 'Shipping is free with a second model';
    }
    return 'Perfect as a gift for someone else';
  }

  /* C1.5: "Mon 26 Oct" -- short enough to sit in one row on a phone. */
  function fmtShort(d) {
    try {
      return d.toLocaleDateString(CFG.locale || undefined, { weekday: 'short', day: 'numeric', month: 'short' });
    } catch (e) { return fmtDate(d); }
  }

  /* C1.5.6: every model counts, ready-made ones included (the add-ons are
     already left out of modelGroups). */
  function modelCount(modelGroups) {
    return modelGroups.reduce(function (a, g) {
      return a + g.model.quantity;
    }, 0);
  }

  /* C1.5.8: designed or labelled maps are made to the buyer's spec and cannot be
     cancelled; ready-made maps can, so a cart of only ready-made maps is not told so. */
  function madeToOrder(cart) {
    var custom = cart.items.some(function (it) {
      return !!(it.properties || {}).Coordinates || isLabelAddon(it);
    });
    return custom
      ? (CFG.confirmText || 'Every model is printed to order. Changes and cancellation are not possible after ordering.')
      : (CFG.confirmTextReady || 'Every model is printed to order.');
  }

  function render(cart) {
    if (!panel) return;
    /* A stale error from one action was still on screen through every later
       one, which is why the banner was there the moment the drawer opened. */
    var oldErr = panel.querySelector('.mm-cart-err');
    if (oldErr) oldErr.classList.add('mm-hide');
    var groups = group(cart);
    var priorityId = CFG.priorityVariantId;
    var priorityLine = priorityId ? lineIdFor(priorityId, cart) : null;
    var priorityOn = !!priorityLine;
    var accId = CFG.accessoryVariantId;
    var accLineKey = accId ? lineIdFor(accId, cart) : null;
    var accQty = 0, accLinePrice = 0;
    if (accLineKey) {
      cart.items.forEach(function (it) {
        if (it.key === accLineKey) { accQty = it.quantity; accLinePrice = it.original_line_price; }
      });
    }

    // the priority fee, the hanger, the gift note and the stand are not model lines
    var modelGroups = groups.filter(function (g) {
      return String(g.model.variant_id) !== String(priorityId) &&
             String(g.model.variant_id) !== String(accId) &&
             String(g.model.variant_id) !== String(CFG.giftVariantId) &&
             !(CFG.standVariantId && String(g.model.variant_id) === String(CFG.standVariantId));
    });
    var count = modelCount(modelGroups);

    var html = '';
    html += '<header class="mm-cart-head">' +
      '<h2>Your cart' + (count ? ' <span class="mm-cart-count">' + count + '</span>' : '') + '</h2>' +
      '<button type="button" class="mm-cart-x" aria-label="Close">&times;</button>' +
      '</header>';
    html += '<div class="mm-cart-err mm-hide"></div>';
    html += '<div class="mm-cart-body">';

    if (!cart.items.length) {
      html += '<div class="mm-cart-empty"><p>Your cart is empty.</p>' +
        (CFG.configuratorUrl
          ? '<a class="mm-cart-emptybtn" href="' + esc(CFG.configuratorUrl) + '">Build your place</a>'
          : '') + '</div>';
    }

    /* C1.5: free shipping sits at the top, where it is read first, next to the
       tile that gets them there. Drawn from the cart total. */
    if (CFG.freeShipOver > 0 && cart.items.length) {
      var short = CFG.freeShipOver - cart.total_price;
      if (short > 0) {
        var pct = Math.max(4, Math.min(100,
          Math.round((cart.total_price / CFG.freeShipOver) * 100)));
        html += '<div class="mm-cart-ship">' +
          '<p>' + esc(CFG.freeShipAway || 'Add') + ' <b>' + money(short) + '</b> ' +
          esc(CFG.freeShipAwayEnd || 'more for free shipping') + '</p>' +
          '<span class="mm-cart-ship-bar"><i style="width:' + pct + '%"></i></span>' +
          '</div>';
      } else {
        html += '<div class="mm-cart-ship is-done">' +
          '<p><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
          'stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
          '<path d="M5 12.5l4.5 4.5L19 7.5"/></svg>' +
          esc(CFG.freeShipGot || 'Free shipping included') + '</p></div>';
      }
    }

    modelGroups.forEach(function (g) {
      var m = g.model, p = m.properties || {};
      /* C1.4 (Muasher): a made-to-order model line takes a notes box. C1.5: it
         stays shut behind a link until there is something in it. */
      var hasNote = !!(p.Coordinates && !p._linkedTo);
      var noteKey = String(p.Coordinates || m.key);
      var noteShown = hasNote && (noteOpen[noteKey] || (p.Notes != null && String(p.Notes).trim() !== ''));
      html += '<div class="mm-cart-line' + (hasNote ? ' mm-has-note' : '') +
        (noteShown ? ' is-note-open' : '') + '" data-key="' + esc(m.key) + '">';
      var thumb = ownThumb(m, modelGroups.length === 1) || m.image;
      html += '<div class="mm-cart-thumb">' +
        (thumb ? '<img src="' + esc(thumb) + '" alt="">' : THUMB_FALLBACK) + '</div>';
      html += '<div class="mm-cart-info">';
      html += '<div class="mm-cart-top"><h3>' + (p.Location ? esc(p.Location) : esc(m.product_title)) + '</h3>' +
        '<div class="mm-cart-lineprice">' +
        money(m.original_line_price + g.extras.reduce(function (a, x) {
          return a + x.original_line_price;
        }, 0)) + '</div></div>';

      /* C1.5: size, frame and colour on one line. The price breakdown and the
         coordinates line are gone: the colour is free, and the numbers were
         for us, not for the customer. */
      var specBits = (m.variant_title && m.variant_title !== 'Default Title')
        ? m.variant_title.split(/\s*\/\s*/)
        : [p.Frame ? p.Frame + ' frame' : null, p.Colourway || null].filter(Boolean);
      if (specBits.length) {
        html += '<p class="mm-cart-sub">' + esc(specBits.join(' · ')) + '</p>';
      }
      /* C1.4 (Muasher): the name the configurator puts on the model. */
      var labelTxt = noteLabel(p);
      if (labelTxt) html += '<p class="mm-cart-label">Label: ' + esc(labelTxt) + '</p>';
      /* Any paid add-on line tied to this model, by name and price. */
      g.extras.forEach(function (x) {
        var name = (x.variant_title && x.variant_title !== 'Default Title')
          ? x.variant_title : x.product_title;
        html += '<p class="mm-cart-extra">+ ' + esc(name) + ' · ' +
          money(x.original_line_price / Math.max(x.quantity, 1)) + '</p>';
      });

      html += '<div class="mm-cart-ctl">' +
        '<div class="mm-cart-qty">' +
        '<button type="button" class="mm-qty-dn" aria-label="Decrease">−</button>' +
        '<span>' + m.quantity + '</span>' +
        '<button type="button" class="mm-qty-up" aria-label="Increase">+</button>' +
        '</div>' +
        (hasNote ? '<button type="button" class="mm-cart-link mm-note-open"' +
          (noteShown ? ' hidden' : '') + '>+ Add a note about this map</button>' : '') +
        (p._spec && CFG.showLoadConfig
          ? '<button type="button" class="mm-cart-link mm-cart-load">Load configuration</button>' : '') +
        '</div>';
      html += '</div>';
      if (hasNote) html += noteHtml(m, p);
      html += '</div>';
    });

    /* C1.5: "Add another place" is a full-width tile with a blue plus, centred
       and drawn (an SVG, so no font can push it off centre). */
    if (cart.items.length) {
      html += '<button type="button" class="mm-cart-bundle">' +
        '<i aria-hidden="true"><svg width="16" height="16" viewBox="0 0 16 16" fill="none">' +
        '<path d="M8 2v12M2 8h12" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/>' +
        '</svg></i><span><strong>Add another place</strong>' +
        '<em class="mm-bundle-sub">' + esc(bundleSub(cart, modelGroups)) + '</em></span></button>';
    }

    /* ----------------------------- C1.5 extras -------------------------- */
    var rows = '';

    /* Priority production: one row that turns on and off. The date is the one
       thing that sells it, so it is in the row itself. */
    if (priorityId && cart.items.length) {
      var stdDays = parseInt(CFG.standardDays, 10); if (isNaN(stdDays)) stdDays = 4;
      var priDays = parseInt(CFG.priorityDays, 10); if (isNaN(priDays)) priDays = 1;
      rows += '<div class="mm-x mm-cart-prio' + (priorityOn ? ' is-on' : '') + '">' +
        '<span class="mm-x-ic" aria-hidden="true"><svg width="30" height="30" viewBox="0 0 24 24" fill="none" ' +
        'stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' +
        '<path d="M13 2L4 14h7l-1 8 9-12h-7l1-8z"/></svg></span>' +
        '<div class="mm-x-txt"><strong>Priority production</strong>' +
        '<p>Ships by <b>' + esc(fmtShort(shipDate(priDays))) + '</b> instead of ' +
        esc(fmtShort(shipDate(stdDays))) + '</p></div>' +
        '<div class="mm-x-side"><span class="mm-x-price">+' + money(addonPrice(CFG.priorityVariantId, CFG.priorityPrice)) + '</span>' +
        '<button type="button" class="mm-x-btn mm-prio-toggle" aria-pressed="' + (priorityOn ? 'true' : 'false') + '">' +
        (priorityOn ? 'Added' : 'Add') + '</button></div></div>';
    }

    /* Gift note. Shut until tapped; the C1.3 rule stands: no message, no note. */
    var giftId = CFG.giftVariantId;
    var giftLineKey = giftId ? lineIdFor(giftId, cart) : null;
    var giftMsg = '';
    if (giftLineKey) {
      cart.items.forEach(function (it) {
        if (it.key === giftLineKey) giftMsg = (it.properties || {})['Gift message'] || '';
      });
      if (/^\(no message\)$/i.test(giftMsg.trim())) giftMsg = '';
    }
    if (giftId && cart.items.length) {
      var gOpen = giftOpen || !!giftLineKey;
      rows += '<div class="mm-x mm-cart-gift' + (giftLineKey ? ' is-on' : '') + (gOpen ? ' is-open' : '') + '">' +
        '<button type="button" class="mm-cart-gift-bar" aria-expanded="' + (gOpen ? 'true' : 'false') + '">' +
          '<img class="mm-x-img" src="' + esc(giftImage()) + '" alt="" aria-hidden="true">' +
          '<span class="mm-x-txt"><strong>Gift note</strong>' +
          '<span class="mm-x-p">' + esc(GIFT_LINE) + '</span></span>' +
          '<span class="mm-x-side"><span class="mm-x-price">+' + money(addonPrice(CFG.giftVariantId, CFG.giftPrice)) + '</span>' +
          '<span class="mm-x-btn mm-gift-state">' + (giftLineKey ? 'Added' : 'Add') + '</span></span>' +
        '</button>' +
        '<div class="mm-cart-gift-body">' +
          '<p class="mm-gift-help" id="mm-gift-help">' + esc(GIFT_HELP) + '</p>' +
          '<textarea class="mm-cart-giftmsg" rows="3" aria-label="Your gift message" ' +
            'aria-describedby="mm-gift-help" maxlength="' +
            (CFG.giftMaxChars || 200) + '" placeholder="' +
            esc(GIFT_EXAMPLE) + '">' + esc(giftMsg) + '</textarea>' +
          '<div class="mm-gift-foot"><em class="mm-cart-giftcount"></em>' +
          '<button type="button" class="mm-cart-btn mm-cart-gifttoggle">' +
            esc(giftLineKey
              ? (CFG.giftRemoveLabel || 'Remove gift note')
              : (CFG.giftAddLabel || 'Add gift note')) + '</button></div>' +
        '</div></div>';
    }

    /* The rotating stand: only beside a size it fits, or once it is in the
       cart so it can be taken out. The video is the selling point. */
    var standId = CFG.standVariantId;
    var standKey = standId ? lineIdFor(standId, cart) : null;
    var standQty = 0, standLinePrice = 0;
    if (standKey) {
      cart.items.forEach(function (it) {
        if (it.key === standKey) { standQty = it.quantity; standLinePrice = it.original_line_price; }
      });
    }
    if (standId && cart.items.length && (standQty || standFits(cart))) {
      var media = CFG.standVideo
        ? '<video class="mm-stand-vid" src="' + esc(CFG.standVideo) + '"' +
          (CFG.standImage ? ' poster="' + esc(CFG.standImage) + '"' : '') +
          ' autoplay muted loop playsinline preload="metadata" aria-hidden="true"></video>'
        : (CFG.standImage ? '<img class="mm-stand-vid" src="' + esc(CFG.standImage) + '" alt="">' : '');
      rows += '<div class="mm-x mm-cart-stand' + (standQty ? ' is-on' : '') + '">' + media +
        '<div class="mm-x-txt"><strong>' + esc(CFG.standTitle || 'Rotating display stand') + '</strong>' +
        '<p>' + esc(CFG.standBody || '') + '</p></div>' +
        (standQty
          ? '<div class="mm-x-side">' +
              '<div class="mm-cart-qty">' +
              '<button type="button" class="mm-stand-dn" aria-label="Fewer">−</button>' +
              '<span>' + standQty + '</span>' +
              '<button type="button" class="mm-stand-up" aria-label="More">+</button>' +
              '</div>' +
              '<span class="mm-cart-up-price">' + money(standLinePrice) + '</span>' +
            '</div>'
          : '<div class="mm-x-side"><span class="mm-x-price">' + money(addonPrice(CFG.standVariantId, CFG.standPrice)) + '</span>' +
            '<button type="button" class="mm-x-btn mm-cart-addstand">Add</button></div>') +
        '</div>';
    }

    /* C1.5: the wall hanger is no longer offered. A hanger already in a cart
       still shows here, with its stepper, so it can be taken out. */
    if (accId && accQty) {
      rows += '<div class="mm-x mm-x-acc is-on">' +
        (CFG.accessoryImage ? '<img class="mm-stand-vid" src="' + esc(CFG.accessoryImage) + '" alt="">' : '') +
        '<div class="mm-x-txt"><strong>' + esc(CFG.accessoryTitle || 'Wall hanger') + '</strong></div>' +
        '<div class="mm-x-side">' +
          '<div class="mm-cart-qty">' +
          '<button type="button" class="mm-acc-dn" aria-label="Fewer">−</button>' +
          '<span>' + accQty + '</span>' +
          '<button type="button" class="mm-acc-up" aria-label="More">+</button>' +
          '</div>' +
          '<span class="mm-cart-up-price">' + money(accLinePrice) + '</span>' +
        '</div></div>';
    }

    if (rows) html += '<div class="mm-xs"><h4>Add to your order</h4>' + rows + '</div>';

    html += '</div>'; // body

    if (cart.items.length) {
      var lock = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
        'stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/></svg>';
      var shield = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
        'stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<path d="M12 3l7 3v5c0 4.5-3 8.3-7 10-4-1.7-7-5.5-7-10V6l7-3z"/><path d="M9 12l2 2 4-4"/></svg>';
      /* C1.5: a footer that stays put. The made-to-order disclosure stays
         directly above the button, as before; the promise sits under it. */
      html += '<footer class="mm-cart-foot">' +
        '<div class="mm-cart-total"><span>Total</span><b>' + money(cart.total_price) + '</b></div>' +
        '<p class="mm-cart-tax">Taxes included. Shipping calculated at checkout.</p>' +
        '<p class="mm-cart-terms">' + esc(madeToOrder(cart)) + '</p>' +
        '<button type="button" class="mm-cart-checkout">' + lock + '<span>Checkout</span>' +
          '<b class="mm-co-total">' + money(cart.total_price) + '</b></button>' +
        '<p class="mm-cart-promise">' + shield + '<span>' + esc(CFG.confirmSubText ||
          'Love it, or your money back.') + '</span></p>' +
        (CFG.paymentIcons && CFG.paymentIcons.length
          ? '<div class="mm-cart-icons">' +
            CFG.paymentIcons.map(function (u) {
              return '<img src="' + esc(u) + '" alt="">';
            }).join('') + '</div>'
          : '') +
        '</footer>';
    }

    /* Even a full rebuild should not throw away where the customer was or what
       they had typed. */
    var keepScroll = panel.scrollTop;
    var typed = panel.querySelector('.mm-cart-giftmsg');
    var keepMsg = typed ? typed.value : null;
    var keepNotes = noteKeep();

    panel.innerHTML = html;

    if (keepMsg) {
      var box2 = panel.querySelector('.mm-cart-giftmsg');
      if (box2 && !box2.value) box2.value = keepMsg;
    }
    noteRestore(keepNotes);
    panel.scrollTop = keepScroll;
    wire(cart, groups, priorityLine);
  }

  /* -------------------------------- wiring ------------------------------ */

  /* rebound=true means the nodes already carry listeners from a previous pass;
     cloning each control drops the stale closures before the new ones attach. */
  function wire(cart, groups, priorityLine, rebound) {
    var q = function (s) { return panel.querySelector(s); };
    if (rebound) {
      var sel = '.mm-qty-up,.mm-qty-dn,.mm-acc-up,.mm-acc-dn,.mm-cart-addacc,' +
                '.mm-stand-up,.mm-stand-dn,.mm-cart-addstand,' +
                '.mm-prio-toggle,.mm-cart-gifttoggle,.mm-cart-gift-bar,.mm-cart-bundle,' +
                '.mm-cart-load,.mm-note-open';
      Array.prototype.forEach.call(panel.querySelectorAll(sel), function (n) {
        n.parentNode.replaceChild(n.cloneNode(true), n);
      });
    }

    var xBtn = q('.mm-cart-x');
    if (xBtn && !rebound) xBtn.addEventListener('click', close);

    var acc = q('.mm-cart-addacc');
    if (acc) {
      acc.addEventListener('click', function () {
        /* Two by default. A framed model needs a hook at each top corner to hang
           straight, so one is the wrong answer nearly every time -- and it is a
           far easier number to lower than to raise. */
        var first = parseInt(CFG.accessoryFirstQty, 10);
        if (isNaN(first) || first < 1) first = 2;
        mutate(function () {
          return api('cart/add.js', {
            items: [{ id: CFG.accessoryVariantId, quantity: first }]
          });
        });
      });
    }
    var accKeyNow = CFG.accessoryVariantId ? lineIdFor(CFG.accessoryVariantId, cart) : null;
    var accUp = q('.mm-acc-up'), accDn = q('.mm-acc-dn');
    if (accUp && accKeyNow) {
      var accNow = 0;
      cart.items.forEach(function (it) { if (it.key === accKeyNow) accNow = it.quantity; });
      /* Optimistic: the number moves on the tap, the request follows. */
      var accSpan = panel.querySelector('.mm-x-acc .mm-cart-qty span');
      function accSet(n) {
        if (n < 0) return;
        accNow = n;
        if (accSpan) accSpan.textContent = n;
        mutate(function () {
          return api('cart/change.js', { id: accKeyNow, quantity: n });
        });
      }
      accUp.addEventListener('click', function () { accSet(accNow + 1); });
      accDn.addEventListener('click', function () { accSet(accNow - 1); });
    }

    /* C1.4: the stand -- one on the first tap, then a stepper. */
    var addStand = q('.mm-cart-addstand');
    if (addStand) {
      addStand.addEventListener('click', function () {
        mutate(function () {
          return api('cart/add.js', { items: [{ id: CFG.standVariantId, quantity: 1 }] });
        });
      });
    }
    var standKeyNow = CFG.standVariantId ? lineIdFor(CFG.standVariantId, cart) : null;
    var stUp = q('.mm-stand-up'), stDn = q('.mm-stand-dn');
    if (stUp && stDn && standKeyNow) {
      var stNow = 0;
      cart.items.forEach(function (it) { if (it.key === standKeyNow) stNow = it.quantity; });
      var stSpan = panel.querySelector('.mm-cart-stand .mm-cart-qty span');
      function stSet(n) {
        if (n < 0) return;
        stNow = n;
        if (stSpan) stSpan.textContent = n;
        mutate(function () {
          return api('cart/change.js', { id: standKeyNow, quantity: n });
        });
      }
      stUp.addEventListener('click', function () { stSet(stNow + 1); });
      stDn.addEventListener('click', function () { stSet(stNow - 1); });
    }

    Array.prototype.forEach.call(panel.querySelectorAll('.mm-cart-line'), function (node) {
      var key = node.getAttribute('data-key');
      var g = groups.filter(function (x) { return x.model.key === key; })[0];
      if (!g) return;

      /* The number updates on the spot and the request goes once the clicking
         stops. Firing per click meant four taps queued four round trips, each
         re-rendering the panel underneath the finger doing the tapping. */
      var shown = node.querySelector('.mm-cart-qty span');

      function setQty(n) {
        if (n < 0) return;
        if (n === 0 && !window.confirm('Remove this model from your cart?')) return;
        qtyPending = n;
        if (shown) shown.textContent = n;
        if (qtyTimer) clearTimeout(qtyTimer);
        qtyTimer = setTimeout(function () {
          var target = qtyPending;
          qtyTimer = null; qtyPending = null;
          /* Add-ons move with their model or the customer pays for two plaques
             on one map. Sequential: the cart API rejects concurrent writes. */
          mutate(function () {
            /* C1.4: a saved note gives the line a new key; read it now. */
            var liveKey = liveKeyOf(node.getAttribute('data-key') || key);
            /* C1.5.5: only this model's share of each add-on moves, worked out
               from the cart as it is now (another model of the same place may
               share the line). A share follows the map count: 1 label on 1 map
               becomes 2 on 2 maps and 0 when the map goes. */
            return getCart().then(function (fresh) {
              var fg = group(fresh).filter(function (y) { return y.model.key === liveKey; })[0] || g;
              var before = Math.max(fg.model.quantity, 1);
              var run = api('cart/change.js', { id: liveKey, quantity: target });
              fg.extras.forEach(function (x) {
                var want = Math.max(0, x._lineQty - x.quantity + Math.round(x.quantity * target / before));
                if (want === x._lineQty) return;
                run = run.then(function () {
                  return api('cart/change.js', { id: x.key, quantity: want });
                });
              });
              return run;
            });
          });
        }, 450);
      }

      node.querySelector('.mm-qty-up').addEventListener('click', function () {
        setQty((qtyPending != null ? qtyPending : g.model.quantity) + 1);
      });
      node.querySelector('.mm-qty-dn').addEventListener('click', function () {
        setQty((qtyPending != null ? qtyPending : g.model.quantity) - 1);
      });

      var load = node.querySelector('.mm-cart-load');
      if (load) {
        load.addEventListener('click', function () {
          var spec = (g.model.properties || {})._spec;
          if (!spec) return;
          try {
            window.location.href = (CFG.configuratorUrl || '/') +
              '#mm=' + encodeURIComponent(spec);
          } catch (e) { /* nothing useful to do */ }
        });
      }
    });

    wireNotes();

    /* C1.5: "+ Add a note about this map" opens that line's notes box. */
    Array.prototype.forEach.call(panel.querySelectorAll('.mm-note-open'), function (b) {
      b.addEventListener('click', function () {
        var line = b.closest('.mm-cart-line');
        if (!line) return;
        var ta = line.querySelector('.mm-cart-notemsg');
        noteOpen[String((ta && ta.getAttribute('data-coords')) || line.getAttribute('data-key'))] = true;
        line.classList.add('is-note-open');
        b.hidden = true;
        if (ta) { try { ta.focus(); } catch (eF) {} }
      });
    });

    var bundle = q('.mm-cart-bundle');
    if (bundle) {
      bundle.addEventListener('click', function () {
        close();
        /* "Add another model" used to hand the customer back their LAST model.
           The configurator saves every choice to sessionStorage and restores it
           on load, and nothing cleared it -- so this landed them on the exact
           thing they had just bought, steps already ticked. Worse on the
           configurator page itself, where this only scrolled: the finished
           model was still sitting there, fully configured.

           ?mmnew=1 tells the configurator to keep the place and reset the rest;
           the event does the same when there is no navigation to carry it. */
        if (CFG.configuratorUrl && location.pathname !== CFG.configuratorUrl) {
          var u = CFG.configuratorUrl;
          window.location.href = u + (u.indexOf('?') === -1 ? '?' : '&') + 'mmnew=1';
        } else {
          try { window.dispatchEvent(new CustomEvent('mm:newmodel')); }
          catch (e) {
            /* No CustomEvent constructor: old Safari. */
            try {
              var ev = document.createEvent('Event');
              ev.initEvent('mm:newmodel', true, true);
              window.dispatchEvent(ev);
            } catch (e2) { /* the scroll below is still better than nothing */ }
          }
          var top = document.querySelector('[data-mm-settings]');
          if (top && top.scrollIntoView) top.scrollIntoView({ behavior: 'smooth' });
        }
      });
    }

    /* C1.2: the gift note card opens and closes; the choice survives re-renders. */
    var giftBar = q('.mm-cart-gift-bar');
    if (giftBar) {
      giftBar.addEventListener('click', function () {
        var card = panel.querySelector('.mm-cart-gift');
        if (!card) return;
        giftOpen = !card.classList.contains('is-open');
        card.classList.toggle('is-open', giftOpen);
        giftBar.setAttribute('aria-expanded', giftOpen ? 'true' : 'false');
        if (giftOpen) { var mb = panel.querySelector('.mm-cart-giftmsg'); if (mb) try { mb.focus(); } catch (eF) {} }
      });
    }

    var giftBtn = q('.mm-cart-gifttoggle');
    if (giftBtn) {
      /* Looked up fresh on each use rather than held, so a re-render between
         typing and blurring cannot leave a stale reference behind. */
      function msgBox() { return panel.querySelector('.mm-cart-giftmsg'); }
      function msgText() {
        var el = msgBox();
        return el && el.value ? el.value.trim() : '';
      }
      var box = msgBox();
      var counter = q('.mm-cart-giftcount');
      var maxc = CFG.giftMaxChars || 200;
      var giftKey = CFG.giftVariantId ? lineIdFor(CFG.giftVariantId, cart) : null;

      function tick() {
        var el = msgBox();
        if (counter && el) {
          counter.textContent = el.value.length + ' / ' + maxc;
          counter.style.color = '';
        }
        if (el) el.style.borderColor = '';
      }
      /* C1.3: the box keeps its node across patches, so wire it once. */
      if (box && !box._mmWired) {
        box._mmWired = true;
        box.addEventListener('input', tick);
        /* Saved on blur rather than on every keystroke -- the cart API is not
           something to hit on each character. Cleared to nothing means the
           note comes off the cart: no message, no note, no charge. */
        box.addEventListener('blur', function () {
          var key = panel._mmGiftKey;
          if (!key) return;
          var text = msgText();
          if (!text) {
            var card0 = panel.querySelector('.mm-cart-gift');
            if (card0) card0.classList.remove('is-on');
            var b0 = panel.querySelector('.mm-cart-gifttoggle');
            if (b0) b0.textContent = CFG.giftAddLabel || 'Add gift note';
            mutate(function () { return setVariantQty(CFG.giftVariantId, 0); });
            return;
          }
          mutate(function () {
            return api('cart/change.js', {
              id: key, quantity: 1,
              properties: { 'Gift message': text }
            });
          });
        });
      }
      if (box) tick();
      panel._mmGiftKey = giftKey;

      giftBtn.addEventListener('click', function () {
        // flip the card and the label immediately; the request catches up
        var card = panel.querySelector('.mm-cart-gift');
        if (giftKey) {
          if (card) card.classList.remove('is-on');
          giftBtn.textContent = CFG.giftAddLabel || 'Add gift note';
          mutate(function () {
            return setVariantQty(CFG.giftVariantId, 0);
          });
        } else {
          /* C1.3: no message, no note. Mark the box and ask, instead of
             adding a €5 line that says "(no message)". */
          var text = msgText();
          if (!text) { giftMissing(); return; }
          if (card) card.classList.add('is-on');
          giftBtn.textContent = CFG.giftRemoveLabel || 'Remove gift note';
          mutate(function () {
            return api('cart/add.js', {
              items: [{
                id: CFG.giftVariantId, quantity: 1,
                properties: { 'Gift message': text }
              }]
            });
          });
        }
      });
    }

    /* C1.3: one place that says "write the message first". Opens the card if
       it is shut, colours the box and the counter, puts the cursor in it. */
    function giftMissing() {
      var card = panel.querySelector('.mm-cart-gift');
      var bar = panel.querySelector('.mm-cart-gift-bar');
      if (card && !card.classList.contains('is-open')) {
        giftOpen = true;
        card.classList.add('is-open');
        if (bar) bar.setAttribute('aria-expanded', 'true');
      }
      var el = panel.querySelector('.mm-cart-giftmsg');
      var c = panel.querySelector('.mm-cart-giftcount');
      if (c) { c.textContent = CFG.giftMissingText || 'Write your message first'; c.style.color = '#C0392B'; }
      if (el) {
        el.style.borderColor = '#C0392B';
        try { el.focus(); } catch (eF) {}
        try { el.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (eS) {}
      }
    }

    /* C1.5: one toggle. The row lights up on the tap; the cart follows. */
    var prioBtn = q('.mm-prio-toggle');
    if (prioBtn) {
      prioBtn.addEventListener('click', function () {
        var on = prioBtn.getAttribute('aria-pressed') !== 'true';
        prioPaint(on);
        mutate(function () { return setVariantQty(CFG.priorityVariantId, on ? 1 : 0); });
      });
    }
    var std = null, fast = null;
    /* The highlight moves on the tap. Waiting for a round trip to show which
       option is selected is what made this feel like a page reload. */
    /* Both buttons always repaint and always reconcile. They used to bail out
       when the captured line key disagreed with what was clicked, so a tap
       could land on nothing at all -- and when it did fire, it fired a key that
       may already have been replaced by a re-render. */
    if (std) {
      std.addEventListener('click', function () {
        std.classList.add('is-on'); if (fast) fast.classList.remove('is-on');
        mutate(function () { return setVariantQty(CFG.priorityVariantId, 0); });
      });
    }
    if (fast) {
      fast.addEventListener('click', function () {
        fast.classList.add('is-on'); if (std) std.classList.remove('is-on');
        mutate(function () { return setVariantQty(CFG.priorityVariantId, 1); });
      });
    }

    /* Straight to checkout. The tick that used to gate this is gone, so there
       is no locked state to toggle and nothing to flash at -- the button does
       the one thing its label promises. */
    var go = q('.mm-cart-checkout');
    if (go && !rebound) {
      go.addEventListener('click', function () {
        /* C1.3: a note in the cart with nothing to write on it does not go to
           checkout. Read from the DOM, not the cart captured at wire time --
           patches leave this listener in place with a stale cart. */
        var onCard = panel.querySelector('.mm-cart-gift.is-on');
        if (onCard) {
          var el = panel.querySelector('.mm-cart-giftmsg');
          var t = el && el.value ? el.value.trim() : '';
          if (!t || /^\(no message\)$/i.test(t)) { giftMissing(); return; }
        }
        /* The tap on Checkout blurs the message box first, and that blur
           queues the save (or the removal). Leave only once the queue is
           empty, or the order carries whatever was there before. */
        flushNotes();
        go.disabled = true;
        var went = false;
        var leave = function () {
          if (went) return;
          went = true;
          window.location.href = root + 'checkout';
        };
        setTimeout(leave, 4000);
        chain.then(leave, leave);
      });
    }
  }

  /* -------------------------------- export ------------------------------ */

  window.MMCart = { open: open, close: close, refresh: refresh };
})();